module.exports = __webpack_public_path__ + "img/arrow_gray.6a63b29b.svg";